import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Headers } from '@angular/http';
import { SessionService } from '../session/session.service';
import { SystemConfig } from '../../config/system-config';
import { TicketRequest } from '../../domain/ticket-request';

@Injectable()
export class BettingService {

  constructor(public sessionService: SessionService,
              public http: Http) {
  }

  placeBet(drawings: number, numbers: number[], stake: number): Observable<any> {
    let ticketRequest: TicketRequest = new TicketRequest();
    ticketRequest.Drawings = drawings;
    ticketRequest.SelectedNumbers = numbers;
    ticketRequest.Stake = stake;
    ticketRequest.BingoGameId = this.sessionService.currentBingoGameId;

    return this.http.post(SystemConfig.Endpoint.TICKET, ticketRequest, {headers: new Headers()});
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/betting/betting.service.ts